/**************************************
 * [FUNCTION]: Product page DOMContentLoaded logic and gallery setup
 ***************************************/
document.addEventListener('DOMContentLoaded', (e) => {
	document.querySelector('body').classList.add('testRunning')
	let mql = window.matchMedia('(max-width: 768px)')

	// Set up product gallery for desktop/mobile
	const setupGallery = () => {
		const mainProducGallery = document.querySelector('[data-main-media][data-t4s-gallery]')

		const isTesting = document.documentElement.classList.contains('js-PDP-video-testing')
		const testingVideo = document.querySelector('[data-product-single-media-testing]')
		const thumbnailVideoEls = document.querySelectorAll('[data-thumb__scroller] .t4s-carousel__nav-item')

		if (mql.matches) {
			//Is mobile:
			mainProducGallery?.flickityt4s?.destroy?.()

			// if (!isTesting && testingVideo) {
			// 	testingVideo.remove()
			// 	thumbnailVideoEls[3].remove()
			// }

			mainProducGallery.flickityt4s = new T4SThemeSP.Carousel(mainProducGallery)
		} else {
			// Is desktop:
			// if (!isTesting && testingVideo) {
			// 	testingVideo.remove()
			// 	thumbnailVideoEls[3].remove()
			// }

			mainProducGallery?.flickityt4s?.destroy?.()
		}
	}

	if (mql.matches) setupGallery()

	let mainCarouselArgs
	const mainProducGallery = document.querySelector('[data-main-media][data-t4s-gallery]')

	if (mainProducGallery && !mql.matches) {
		mainProducGallery.classList.add('isLoading')
		const awaitGalleryInitialization = setInterval(() => {
			if (mainProducGallery.flickityt4s) {
				clearInterval(awaitGalleryInitialization)
				mainCarouselArgs = mainProducGallery.flickityt4s.args
				mainProducGallery.classList.add('desktop--gallery')
				setupGallery()

				// Load more button for gallery if too many photos
				const mediaSlides = mainProducGallery.querySelectorAll('[data-product-single-media-wrapper]')
				if (mediaSlides.length > 4) {
					mainProducGallery.insertAdjacentHTML(
						'afterend',
						`<div class="load-more-button">
	            <span>Show More</span>
	            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
	                <path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5"></path>
	            </svg>
	        </div>`
					)
					mainProducGallery.parentElement.querySelector('.load-more-button').addEventListener('click', (e) => {
						const loadMoreButton = document.querySelector('.load-more-button')
						const mainProducGallery = document.querySelector('[data-t4s-gallery]')
						if (mainProducGallery.classList.contains('gallery--expended')) {
							mainProducGallery.classList.remove('gallery--expended')
							loadMoreButton.querySelector('span').innerHTML = 'Show More'

							//Scroll higher so the user is not stranded
							const currentDistanceFromTop = loadMoreButton.getBoundingClientRect().top
							scrollTo({
								top: loadMoreButton.offsetTop - 350,
								left: 0,
								behavior: 'instant',
							})
						} else {
							mainProducGallery.classList.add('gallery--expended')
							loadMoreButton.querySelector('span').innerHTML = 'Show Less'
						}
					})
				}
				//Add Load more Btn:

				mainProducGallery.classList.remove('isLoading')

				const videos = document.querySelectorAll('.product-icon-img-desktop iframe')

				// Setup YouTube players for each video
				videos.forEach((videoElement) => {
					const videoId = videoElement.id // Assuming you have a way to get this

					console.log('videoid', videoId)

					const player = new YT.Player(videoElement, {
						videoId: videoId,
						events: {
							onStateChange: onPlayerStateChange,
						},
					})

					const videoThumbnail = videoElement
						.closest('[data-media-type="external_video"]')
						.querySelector('.t4s-product__media')

					videoThumbnail.addEventListener('click', (e) => {
						if (videoThumbnail.classList.contains('alreadyPlayed')) return
						videoThumbnail.classList.add('alreadyPlayed')

						videoThumbnail.classList.add('loading')
						let vidURL = videoElement.src
						vidURL = vidURL.replace('?autoplay=0', '?autoplay=1')
						videoElement.src = ''
						videoElement.src = vidURL
						setTimeout(() => {
							videoThumbnail.classList.remove('loading')

							videoThumbnail.classList.add('hideThumbnail')
						}, 500)
					})

					let videoStarted = false // Flag for start tracking
					let halfVideoWatched = false // Flag for half watched tracking
					let intervalId

					// YouTube player state event handler
					function onPlayerStateChange(event) {
						if (event.data == YT.PlayerState.PLAYING) {
							if (!videoStarted) {
								console.log('video started')
								trackIntelligemsEvent('Video Started')
								videoStarted = true
							}

							if (!intervalId) {
								intervalId = setInterval(() => {
									const currentTime = player?.playerInfo?.currentTime
									const duration = player?.playerInfo?.duration
									if (currentTime >= duration / 2 && !halfVideoWatched) {
										console.log('half video watched')
										trackIntelligemsEvent('Half Video Watched')
										halfVideoWatched = true
										clearInterval(intervalId)
										intervalId = null
									}
								}, 1000)
							}
						} else if (event.data == YT.PlayerState.ENDED || event.data == YT.PlayerState.PAUSED) {
							if (intervalId) {
								clearInterval(intervalId)
								intervalId = null
							}
						}
					}
				})

				window.addEventListener('resize', setupGallery)
			}
		}, 500)
	}
})

/**************************************
 * [FUNCTION]: Stock display on variant change
 ***************************************/
jQuery_T4NT(document).ready(function ($) {
	$(document).on('variant:changed', function (evt) {
		const stockElement = document.querySelector('.product__low-stock')
		if (evt.currentVariant.inventory_quantity < 6 && evt.currentVariant.inventory_quantity > 0) {
			stockElement.style.display = 'block'
			stockElement.querySelector('.stock-available').innerHTML = evt.currentVariant.inventory_quantity
		} else {
			stockElement.style.display = 'none'
		}
	})
})

/**************************************
 * [FUNCTION]: Wait for DOM element to exist (utility)
 ***************************************/
function waitForElement(querySelector, timeout) {
	return new Promise((resolve, reject) => {
		var timer = false
		if (document.querySelectorAll(querySelector).length) return resolve()
		const observer = new MutationObserver(() => {
			if (document.querySelectorAll(querySelector).length) {
				observer.disconnect()
				if (timer !== false) clearTimeout(timer)
				return resolve()
			}
		})
		observer.observe(document.body, {
			childList: true,
			subtree: true,
		})
		if (timeout)
			timer = setTimeout(() => {
				observer.disconnect()
				reject()
			}, timeout)
	})
}

/**************************************
 * [FUNCTION]: "Show more reviews" toggle handling
 ***************************************/
document.addEventListener('DOMContentLoaded', function () {
	const reviewLoadMoreButton = document.querySelector('#reviewLoadMore')
	if (reviewLoadMoreButton) {
		reviewLoadMoreButton.addEventListener('click', function (e) {
			e.preventDefault()
			document.querySelector('#rapid_reviews_global_featured_list .r_items').classList.toggle('show-more')
			reviewLoadMoreButton.innerHTML = reviewLoadMoreButton.innerHTML === 'Show more' ? 'Show less' : 'Show more'
		})
	}
})

/**************************************
 * [FUNCTION]: YouTube tracking for .plyr__video-wrapper videos
 ***************************************/
waitForElement('.plyr__video-wrapper iframe', 8000).then(() => {
	const videos = document.querySelectorAll('.plyr__video-wrapper iframe')

	videos.forEach((videoElement) => {
		const videoId = videoElement.id // Assuming you have a way to get this

		const player = new YT.Player(videoElement, {
			videoId: videoId,
			events: {
				onStateChange: onPlayerStateChange,
			},
		})

		const videoThumbnail = videoElement
			.closest('[data-media-type="external_video"]')
			.querySelector('.t4s-product__media')

		videoThumbnail.addEventListener('click', (e) => {
			if (videoThumbnail.classList.contains('alreadyPlayed')) return
			videoThumbnail.classList.add('alreadyPlayed')
			videoThumbnail.classList.add('loading')
			let vidURL = videoElement.src
			vidURL = vidURL.replace('?autoplay=0', '?autoplay=1')
			videoElement.src = ''
			videoElement.src = vidURL
			setTimeout(() => {
				videoThumbnail.classList.remove('loading')

				videoThumbnail.classList.add('hideThumbnail')
			}, 500)
		})

		let videoStarted = false
		let halfVideoWatched = false
		let intervalId

		function onPlayerStateChange(event) {
			if (event.data == YT.PlayerState.PLAYING) {
				if (!videoStarted) {
					trackIntelligemsEvent('Video Started')
					videoStarted = true
				}

				if (!intervalId) {
					intervalId = setInterval(() => {
						const currentTime = player?.playerInfo?.currentTime
						const duration = player?.playerInfo?.duration
						if (currentTime >= duration / 2 && !halfVideoWatched) {
							trackIntelligemsEvent('Half Video Watched')
							halfVideoWatched = true
							clearInterval(intervalId)
							intervalId = null
						}
					}, 1000)
				}
			} else if (event.data == YT.PlayerState.ENDED || event.data == YT.PlayerState.PAUSED) {
				if (intervalId) {
					clearInterval(intervalId)
					intervalId = null
				}
			}
		}
	})
})

/**************************************
 * [FUNCTION]: Track custom events for Intelligems
 ***************************************/
function trackIntelligemsEvent(eventToTrack) {
	var igEvents = window.igEvents || []
	igEvents.push({
		event: eventToTrack,
	})
}

/**************************************
 * [FUNCTION]: Update Shop Pay installment price in cart drawer
 ***************************************/
jQuery_T4NT(document).ready(function ($) {
	$(document).on('cart:update:count', function (evt) {
		const price = evt.detail.data?.[1]
		if (!price) return

		document.querySelector('.shop-pay-installments .installment-price').innerText = dividePriceByFour(price)
	})
})

/**************************************
 * [FUNCTION]: Divide a price string by four (utility)
 ***************************************/
function dividePriceByFour(priceString) {
	const currencySymbol = priceString.charAt(0)
	const normalizedNumber = parseFloat(priceString.replace(currencySymbol, '').replace(/,/g, ''))
	const dividedNumber = normalizedNumber / 4
	const resultString =
		currencySymbol +
		dividedNumber.toLocaleString(undefined, {
			minimumFractionDigits: 2,
			maximumFractionDigits: 2,
		})

	return resultString
}

/**************************************
 * [FUNCTION]: Auto-click "popular" reviews sort on product page
 ***************************************/
if (document.querySelector('.t4s-section-main-product')) {
	waitForElement(".rapid_reviews_items [data-sort='popular']", 8000).then(() => {
		document.querySelector(".rapid_reviews_items [data-sort='popular']").click()
		scrollTo(0, 0)
	})
}

/**************************************
 * [FUNCTION]: Set variable-url hrefs to current path when menu drawer appears
 ***************************************/
document.addEventListener('DOMContentLoaded', function () {
	waitForElement('#t4s-menu-drawer .variable-url', 5000)
		.then(() => {
			const currentPath = window.location.pathname
			const variableURL = document.querySelectorAll('.variable-url')

			variableURL.forEach((element) => {
				const url = element.getAttribute('data-domain')
				element.href = url + currentPath
			})
		})
		.catch((e) => {
			// console.error("Couldn't find", e)
		})
})

/**************************************
 * [FUNCTION]: Move Shop Pay widget below ATC button on mobile
 ***************************************/
waitForElement('shopify-payment-terms, .rapid_reviews_stars_badge', 5000).then(() => {
	if (window.innerWidth < 767) {
		const shopPayWidget = document.querySelector('shopify-payment-terms')
		const atcButton = document.querySelector('.t4s-product-form__submit')

		shopPayWidget && atcButton && atcButton.insertAdjacentElement('afterend', shopPayWidget)
	}
})

/**************************************
 * [FUNCTION]: Format price for Shop Pay split
 ***************************************/
function formatPrice(priceString) {
	const currencySymbol = priceString.match(/^[^\d]+/)[0]
	const numericValue = parseFloat(priceString.replace(/[^\d.]/g, ''))
	const dividedPrice = numericValue / 4
	return `${currencySymbol}${dividedPrice.toFixed(2)}`
}

/**************************************
 * [FUNCTION]: Update ShopPay installment price in slidecart
 ***************************************/
document.addEventListener('cart:update:count', (e) => {
	const totalPrice = e.detail.price
	const installment = document.querySelector('.installment-price')

	if (installment) {
		installment.innerText = formatPrice(totalPrice)
	}
})

/**************************************
 * [FUNCTION]: Initialize KeenSlider for "As Seen On" slider if present
 ***************************************/
if (document.querySelector('.as-seen-on__slider.keen-slider')) {
	var slider = new KeenSlider(
		'.as-seen-on__slider.keen-slider',
		{
			loop: false,
			slides: {
				perView: 1,
				spacing: 8,
			},
			breakpoints: {
				'(min-width: 768px)': {
					loop: false,
					slides: {
						perView: 4,
						spacing: 16,
					},
				},
			},
		},
		[navigation]
	)
}

// KeenSlider navigation functions
function navigation(slider) {
	let wrapper, dots, arrowLeft, arrowRight

	function markup(remove) {
		wrapperMarkup(remove)
		dotMarkup(remove)
		arrowMarkup(remove)
	}

	function removeElement(elment) {
		elment.parentNode.removeChild(elment)
	}

	function createDiv(className) {
		var div = document.createElement('div')
		var classNames = className.split(' ')
		classNames.forEach((name) => div.classList.add(name))
		return div
	}

	function arrowMarkup(remove) {
		if (remove) {
			removeElement(arrowLeft)
			removeElement(arrowRight)
			return
		}
		arrowLeft = createDiv('arrow arrow--left')
		arrowLeft.addEventListener('click', () => slider.prev())
		arrowLeft.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
    <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" />
  </svg>`

		arrowRight = createDiv('arrow arrow--right')
		arrowRight.addEventListener('click', () => slider.next())
		arrowRight.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
    <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
  </svg>`

		wrapper.appendChild(arrowLeft)
		wrapper.appendChild(arrowRight)
	}

	function wrapperMarkup(remove) {
		if (remove) {
			var parent = wrapper.parentNode
			while (wrapper.firstChild) parent.insertBefore(wrapper.firstChild, wrapper)
			removeElement(wrapper)
			return
		}
		wrapper = createDiv('navigation-wrapper')
		slider.container.parentNode.appendChild(wrapper)
		wrapper.appendChild(slider.container)
	}

	function dotMarkup(remove) {
		if (remove) {
			removeElement(dots)
			return
		}
		dots = createDiv('dots')
		slider.track.details.slides.forEach((_e, idx) => {
			var dot = createDiv('dot')
			dot.addEventListener('click', () => slider.moveToIdx(idx))
			dots.appendChild(dot)
		})
		wrapper.appendChild(dots)
	}

	function updateClasses() {
		var slide = slider.track.details.rel
		var slidesPerView = slider.options.slides.perView // Get slides per view

		slide === 0 ? arrowLeft.classList.add('arrow--disabled') : arrowLeft.classList.remove('arrow--disabled')

		// Check if the slide index + slides per view is greater or equal to the total number of slides.
		slide + slidesPerView >= slider.track.details.slides.length
			? arrowRight.classList.add('arrow--disabled')
			: arrowRight.classList.remove('arrow--disabled')

		Array.from(dots.children).forEach(function (dot, idx) {
			idx === slide ? dot.classList.add('dot--active') : dot.classList.remove('dot--active')
		})
	}

	slider.on('created', () => {
		markup()
		updateClasses()
	})

	slider.on('optionsChanged', () => {
		markup(true)
		markup()
		updateClasses()
	})

	slider.on('slideChanged', () => {
		updateClasses()
	})

	slider.on('destroyed', () => {
		markup(true)
	})
}

